export const AMOUNT_ERROR = 'amountError'
export const AUTO_PAYMENT_TYPE = 'autoPaymentType'
export const DDC_REFERENCE_ID_SET = 'ddc_referecne_id_set'
export const DDC_LOADER_TIME = 6000
export const DDC_LOADER_TIME_OUT = 7000
export const IS_DONATION_SELECTED = 'isDonationSelected'
export const IS_RELINK_ACCOUNT = 'isRelinkAccount'
export const PAYMENT_ACCOUNT_ID = 'paymentAccountId'
export const PAYMENT_AMOUNT = 'paymentAmount'
export const PLAID_CONFIRM_MICRODEPOSIT = 'plaid_confirm_redirect'
export const PLAID_REDIRECTED = 'plaid_redirected'
export const RESTORE_FORM = 'restoreForm'
// Constants for Apple Pay
export const FINAL = 'final'
export const SUBTOTAL = 'Subtotal'
export const CONVIENCE_FEE = 'Convenience Fee'
export const CHARITY_DONATION = 'Charity Donation'
export const POSTAL_ADDRESS = 'postalAddress'
export const APPLE_PAY = 'apple_pay'
export const VIA_ENTRATA = '(via Entrata)'
export const ALLOWED_DEBIT_CREDIT = 'is_allowed_debit_credit'